import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a7729c9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drug-a" }

import { onUnmounted, ref, watch } from "vue";
import { useStore } from "@/store";
import { useI18n } from "vue-i18n";

const __default__ = {
  name: "DrugA",
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t } = useI18n();
const { registerInput, UnregisterInput, runnerInputs, updateRunnerInput } =
  useStore();
const inputName = "drug";
registerInput(inputName);
onUnmounted(() => {
  UnregisterInput(inputName);
});

const drug = ref(0);
watch(runnerInputs, () => {
  drug.value = runnerInputs[inputName];
});
const update = () => {
  updateRunnerInput(inputName, drug.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_unref(t)("runner.drugA")) + ": ", 1),
    _withDirectives(_createElementVNode("input", {
      class: "drug",
      type: "range",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((drug).value = $event)),
      onChange: update,
      min: "0",
      max: "1",
      step: "0.01"
    }, null, 544), [
      [_vModelText, drug.value]
    ])
  ]))
}
}

})